export default __webpack_public_path__ + "static/media/collateralIconDark.83c42454.svg";